<template>
    <div id="user-profile-controls" class="position-absolute" ref="profileRef">
        <div @click="toggleMenu">
            <AvaInitials
                classes="ava-xs user-settings"
                :initialsType="AvaInitialsType.Single"
                :user="loggedInUserDetails"
                :showStatus="true"
            />
        </div>

        <!-- Main Menu Dropdown -->
        <div id="profile-menu" v-if="showMenu" class="py-1 rounded shadow" aria-labelledby="User-Settings">
            <div class="menu-item font-size-sm" href="javascript:void(0);" @click="openViewProfile">View Profile</div>
            <div
                class="menu-item font-size-sm"
                href="javascript:void(0);"
                data-bs-toggle="dropdown"
                @click="openSetStatus"
            >
                Set Status
            </div>

            <!-- User Statuses Dropdown -->
            <div class="dropdown-menu status-menu" aria-labelledby="defaultDropdown">
                <a
                    class="dropdown-item font-size-sm"
                    v-for="[key, value] in enumToMap(ProfileStatusEnums)"
                    :key="key"
                    @click="updateStatus(value.value)"
                >
                    <img
                        :src="`${require(`../../../assets/images/chat/status-${value.value === ProfileStatusEnum.InACall ? 'busy' : key}.svg`)}`"
                    />
                    {{ value.name }}
                </a>
            </div>

            <div class="menu-item font-size-sm" href="javascript:void(0);" @click="openSetStatusMsg">
                Set Status Message
            </div>
        </div>

        <!-- View Profile Dropdown -->
        <div v-if="activeMenu === 'profile'" class="user-profile position-absolute p-3 shadow rounded">
            <div class="d-flex align-items-center">
                <div class="position-relative" @click="openProfilePicDialog">
                    <AvaInitials :initialsType="AvaInitialsType.Single" :user="loggedInUserDetails" />
                    <span class="ava-edit-icon">
                        <img :src="`${require(`../../../assets/images/chat/edit-pencil.svg`)}`" />
                    </span>
                </div>

                <div>
                    <div class="ms-2 fw-semibold">{{ userDetails.userName }}</div>
                    <div class="ms-2 fw-semibold user-email">{{ userDetails.email }}</div>
                </div>
            </div>

            <div class="profile-colors bg-white rounded p-2">
                <div class="pb-2 fw-semibold">Change Profile Color</div>
                <div class="d-flex gap-3 mt-1 pb-1">
                    <div
                        v-for="(circle, index) in circles"
                        :key="index"
                        class="circle cursor-pointer"
                        :class="{ selected: index + 1 === userDetails.profileColor }"
                        :style="circleStyle(circle)"
                        @click="updateProfileColor(index)"
                    ></div>
                </div>
            </div>
        </div>

        <!-- Status Message Popup -->
        <div v-if="activeMenu === 'statusMsg'" class="popup-card shadow rounded">
            <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="d-flex flex-column">
                    <div class="fw-bold">Set Status Message</div>
                    <small>{{ userDetails.email }}</small>
                </div>
                <i class="fas fa-times fa-lg mt-3" @click="backToRoot"></i>
            </div>

            <textarea
                class="form-control overflow-hidden"
                rows="3"
                maxlength="280"
                placeholder="Type your status message that should be visible to people"
                v-model="userStatusMsg"
                :disabled="existingStatusMsg !== null"
            ></textarea>

            <select v-if="!existingStatusMsg" class="form-select mt-3" v-model="userStatusMsgTimer">
                <option :value="1">Never</option>
                <option :value="2">Today</option>
                <option :value="3">1 hour</option>
                <option :value="4">4 hours</option>
                <option :value="5">This week</option>
                <option :value="6">Custom</option>
            </select>

            <div v-if="userStatusMsgTimer == 6">
                <div class="ps-1 pt-2 fw-semibold">Status message will disappear after</div>
                <div class="d-flex customized-date-options pt-2 gap-1">
                    <div class="customised-date position-relative w-100">
                        <DatePicker
                            :getDate="changeDate"
                            :options="{
                                container: '.customised-date',
                                orientation: 'left bottom',
                                startDate: dateFrom
                            }"
                        >
                            <div class="input-group date datepickerInput">
                                <input
                                    type="text"
                                    class="form-control"
                                    name="dateFrom"
                                    placeholder="MM/DD/YYYY"
                                    :value="formatDate(dateFrom, 'ddd MMM DD YYYY')"
                                />
                                <div class="input-group-addon input-group-append">
                                    <div class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                            </div>
                        </DatePicker>
                    </div>

                    <TimePicker class="ms-1" :minTime="computedMinTime" @update-props="updateStatusMsgTime">
                        <input
                            id="travel-start-time"
                            type="text"
                            class="form-control"
                            :value="customStatusMsgTime"
                            autocomplete="off"
                            :maxlength="8"
                        />
                    </TimePicker>
                </div>
            </div>

            <button v-if="existingStatusMsg" class="btn btn-md mt-3 btn-primary d-flex m-auto" @click="resetStatusMsg">
                Reset
            </button>

            <button
                v-else
                class="btn btn-md mt-3 btn-primary d-flex m-auto"
                :disabled="!userStatusMsg"
                @click="updateStatusMsg"
            >
                Save
            </button>
        </div>
    </div>
</template>

<script lang="ts" src="./UserProfileManagement.ts"></script>
<style src="./UserProfileManagement.scss"></style>
